import * as React from "react";
import styled from "styled-components";
import TypeAheadDataFilter from "components/common/TypeAheadDataFilter";
const Wrapper = styled.div`
  .control-label {
    padding-top: 0;
  }
`;
const Filter = ({
  children = void 0,
  filterKeys = void 0,
  id = void 0,
  label = void 0,
  onDataFiltered,
  rows
}) => {
  if (filterKeys.length !== 0) {
    return /* @__PURE__ */ React.createElement(Wrapper, { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-md-8" }, /* @__PURE__ */ React.createElement(
      TypeAheadDataFilter,
      {
        id: `${id}-data-filter`,
        label,
        data: rows,
        searchInKeys: filterKeys,
        onDataFiltered
      }
    )), children && /* @__PURE__ */ React.createElement("div", { className: "col-md-4" }, children));
  }
  return null;
};
export default Filter;
